import { render, staticRenderFns } from "./LoginFooter.vue?vue&type=template&id=e722b1aa&"
import script from "./LoginFooter.vue?vue&type=script&lang=ts&"
export * from "./LoginFooter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports